import axios from './../../config/axios';

function getAccounts(params = {}) {
    return axios().get(`/stock/accounts`, { params });
}

function search(query) {
    return axios().get(`/stock/accounts-search`, { params: { search: query } });
}

export default {
    getAccounts,
    search
}